import { render, staticRenderFns } from "./diskon.vue?vue&type=template&id=9bc199fc&"
import script from "./diskon.vue?vue&type=script&lang=js&"
export * from "./diskon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports